import React, { useMemo } from 'react';
import { DataGridWithHeaders } from '@orijinworks/frontend-commons';
import { useAllContactsTabHook } from './useAllContactsTabHook';
import { AddIcon } from '../../../../shared/components/MaterialUIIcons';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { VideoCall, Call } from '@mui/icons-material';
import { ManageVideoCallContact } from '../../index';
import { Box } from '@material-ui/core';
import AddContactModalComponent from '../../../../../components/voice-call/components/add-contact-modal/add-contact-modal.component';
import EditContactModalComponent from '../../../../../components/voice-call/components/edit-contact-modal/edit-contact-modal.component';
import useAddContactModalHook from '../../../../../components/voice-call/components/add-contact-modal/useAddContactModalHook';
import useContactsListComponentHook from '../../../../../components/voice-call/components/contacts-list/useContactsListComponentHook';

const AllContactsTab = ({ activeTab, locationId, classes, isDataRefresh, setDataRefresh }) => {
  const {
    addContactModal,
    learners,
    searchLearnerLoading,
    contact,
    learnerListFetched,
    handleAddModalClose,
    handleAddModalOpen,
    handleContactChange,
    handleAddContact,
    handleSearch,
  } = useAddContactModalHook(locationId, null, setDataRefresh);

  const {
    editContact,
    setEditContact,
    setIsEditSucess,
    setIsEditError,
    isEditContactModalOpen,
    setIsEditContactModalOpen,
    handleEditContactModalClose,
    updateContactStatus, 
    handleEditContactModalOpen
  } = useContactsListComponentHook(activeTab, locationId, classes, isDataRefresh, setDataRefresh);

  const {
    pageSize,
    totalRecords,
    data,
    columns,
    loading,
    videoCallStatus,
    handleSelectedChange,
    lastRefreshed,
    videoCallContactProps,
    formatLastRefreshedTime,
    refreshContacts,
    toggleAddVideoContactModal,
    onPageChange,
    onPageSizeChange,
    onSortChange,
    onFilterChange
  } = useAllContactsTabHook({
    locationId,
    isEditContactModalOpen,
    addContactModal,
    updateContactStatus, 
    handleEditContactModalOpen
  });

   
  const dropDownButtons = useMemo(() => {
    const optionBtns = [
      {
        icon: <Call />,
        label: 'Voice Calls Contact',
        value: 'voiceCallButton',
        onClick: handleAddModalOpen,
      }
    ];
    if (videoCallStatus) {
      optionBtns.push({
        icon: <VideoCall />,
        label: 'Video Calls Contact',
        value: 'videoCallButton',
        onClick: toggleAddVideoContactModal,
      });
    }
    return optionBtns;
  }, [videoCallStatus]);

  return (
    // -24PX: Offsetting parent padding since changing that will impact multiple tabs
    <Box sx={{
      height: '100%',
      marginTop: '-24px',
      '& > div': {
        backgroundColor: 'white'
      },
      '& .main-table': {
        minWidth: 1700
      }
    }}>
      <DataGridWithHeaders
        title="All Contacts"
        subtitle={formatLastRefreshedTime(lastRefreshed)}
        dataGridProps={{
          columns: columns,
          data: [...data],
          pageSize: pageSize,
          pageSizeOptions: [5, 10, 25, 50],
          paginationMode: 'server',
          isLoading: loading,
          onSelectionChange: handleSelectedChange,
          showClearSelectionButton: true,
          serverSidePaginationProps: {
            onPageChange,
            onPageSizeChange,
            onSortChange,
            onFilterChange,
            totalRecordsCount: totalRecords
          },
          onRefreshHandler: refreshContacts,
          primaryButtonProps: {
            text: 'Add Contact',
            variant: 'contained',
            startIcon: <AddIcon />,
            endIcon: <ArrowDropDownIcon />,
            dropdownOptions: dropDownButtons,
          },
          hasActionColumn: true,
          tdStyles: {
            relationshipStatus: {
              minWidth: 200,
              wordBreak: 'break-all'
            },
            contactPhoneNumber: {
              minWidth: 200,
              wordBreak: 'break-all'
            },
            contactFirstName: {
              minWidth: 200,
              wordBreak: 'break-all'
            },
            LearnerCell: {
              minWidth: 200,
              wordBreak: 'break-all'
            },
            relationshipType: {
              minWidth: 200,
              wordBreak: 'break-all'
            },
            productType: {
              minWidth: 100,
              wordBreak: 'break-all',
              color: 'var(--primary-deep)',
              textAlign: 'center'
            },
            contactPhoto: {
              wordBreak: 'break-all',
              minWidth: 200
            }
          },
        }}
      />
      <ManageVideoCallContact
        isAddVideoContactOpen={videoCallContactProps.isOpen}
        onClose={toggleAddVideoContactModal}
        locationId={locationId}
        userId={videoCallContactProps.userId}
      />

      {/* V1 TABS */}
      <AddContactModalComponent
        addContactModal={addContactModal}
        handleAddModalClose={handleAddModalClose}
        learners={learners}
        handleSearch={handleSearch}
        searchLearnerLoading={searchLearnerLoading}
        contact={contact}
        handleContactChange={handleContactChange}
        learnerListFetched={learnerListFetched}
        handleAddContact={handleAddContact}
      />

      <EditContactModalComponent
        isEditContactModalOpen={isEditContactModalOpen}
        setIsEditContactModalOpen={setIsEditContactModalOpen}
        handleEditContactModalClose={handleEditContactModalClose}
        editContact={editContact}
        setEditContact={setEditContact}
        setIsEditSucess={setIsEditSucess}
        setIsEditError={setIsEditError}
      />
      {/* V1 TABS END */}
    </Box>
  );
};

export default AllContactsTab;
